/*
  « La fabrique à idées » : assemble les choix des menus déroulants en une
  adresse de collection filtrée, puis y envoie la visiteuse.

  Chaque choix porte une valeur, de l'une des deux formes :
    /collections/doudous     → devient la collection de destination
    filter.v.price.lte=20    → s'ajoute aux filtres de l'adresse

  Le dernier chemin choisi l'emporte : si la visiteuse dit « un doudou » puis
  « univers forêt et ferme », c'est cette dernière collection qui est ouverte.
  Les filtres, eux, se cumulent tous.

  Sans ce script, le formulaire reste utilisable : il mène simplement à la
  collection de départ.
*/
(function () {
  'use strict';

  function estChemin(valeur) {
    return valeur.charAt(0) === '/';
  }

  function construireUrl(form) {
    var base = form.getAttribute('action') || '/collections/all';
    var filtres = [];
    var selects = form.querySelectorAll('[data-fab-select]');

    for (var i = 0; i < selects.length; i++) {
      var valeur = (selects[i].value || '').trim();
      if (!valeur) continue;

      if (estChemin(valeur)) {
        base = valeur;
      } else {
        // Une même ligne peut porter plusieurs filtres, séparés par &
        var morceaux = valeur.split('&');
        for (var j = 0; j < morceaux.length; j++) {
          var m = morceaux[j].trim();
          if (m) filtres.push(m);
        }
      }
    }

    // On repart d'une adresse propre : la collection choisie ne doit pas
    // conserver les filtres d'une éventuelle visite précédente.
    var url = base.split('?')[0];
    if (filtres.length) {
      url += '?' + filtres.join('&');
    }
    return url;
  }

  function brancher(form) {
    if (form.dataset.fabPret) return;
    form.dataset.fabPret = 'ok';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      window.location.href = construireUrl(form);
    });
  }

  function balayer(racine) {
    var formulaires = (racine || document).querySelectorAll('[data-fabrique]');
    for (var i = 0; i < formulaires.length; i++) {
      brancher(formulaires[i]);
    }
  }

  function demarrer() {
    balayer(document);

    // L'éditeur de thème reconstruit la section à chaque réglage modifié.
    document.addEventListener('shopify:section:load', function (e) {
      balayer(e.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
